import { cn } from '@/lib/utils';
import { forwardRef } from 'react';

type Props = React.ComponentPropsWithoutRef<'div'> & {
  className?: string;
};

/**
 * A styled box component.
 * @param {Props} props - The props for the component
 * @param {string} [props.className] - The class name for the component
 * @param {React.ReactNode} props.children - The children for the component
 * @returns {React.ReactElement} The Box component
 * @example <Box className="text-center">Hello World</Box>
 */
const Box = forwardRef<HTMLDivElement, Props>(({ className = '', children, ...props }, ref) => {
  const styles = 'shadow-md  rounded-lg p-2 bg-background/40 dark:bg-muted/50 dark:shadow-[black]/30';

  return (
    <div ref={ref} className={cn(styles, className)} {...props}>
      {children}
    </div>
  );
});

// Optional: Setze den Displaynamen für die Komponente
Box.displayName = 'Styled-Box';

export default Box;
